export type ResponseValidationErrors = { field: string; messages: string[] }[];

export class ResponseValidationError extends Error {
	constructor(public errors: ResponseValidationErrors) {
		super('Validation failed');

		this.name = 'ResponseValidationError';
	}
}
